<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (!tab.showLoader && user) {
    <div menuSystem [cerrixTab]="tab" class="screen-system" (changeEvent)="handleMenuItemClick($event)">
        <div
            class="user-screens"
            [attr.name]="'userManagementMenuLabel' | t"
            menuItemId="menuItemUserManagement"
            menuicon="fas fa-user-cog"
            menusystemsubmenu
        >
            <div
                [attr.name]="'profileMenuLabel' | t"
                menuItemId="menuItemProfile"
                menuicon="fas fa-user"
                menusystemitem
            >
                <div class="row">
                    <div class="col">
                        <div class="detail-page-card">
                            <div
                                class="detail-page-card-title"
                                data-uiid="user-profile-basic-information-title"
                            >
                                {{ "basicInformationTitle" | t }}
                            </div>
                            <div class="detail-page-card-actions">
                                <button
                                    class="btn btn-raised red"
                                    data-uiid="user-profile-logout-button"
                                    (click)="logout()"
                                >
                                    <i class="fas fa-sign-out-alt"></i>
                                    <span class="ms-2">{{
                                        "logoutButton" | t
                                    }}</span>
                                </button>
                            </div>
                            <div
                                class="detail-page-card-body padded cerrix-control-sm form-group-styling"
                            >
                                <div class="form-group">
                                    <label>{{ "firstnameLabel" | t }}</label>
                                    <input
                                        type="text"
                                        class="form-control form-control-sm"
                                        [(ngModel)]="user.firstname"
                                        disabled
                                    />
                                </div>
                                <div class="form-group">
                                    <label>{{ "lastnameLabel" | t }}</label>
                                    <input
                                        type="text"
                                        class="form-control form-control-sm"
                                        [(ngModel)]="user.lastname"
                                        disabled
                                    />
                                </div>
                                <div class="form-group">
                                    <label>{{ "emailLabel" | t }}</label>
                                    <input
                                        type="email"
                                        class="form-control form-control-sm"
                                        [(ngModel)]="user.email"
                                        disabled
                                    />
                                </div>
                                <div class="form-group">
                                    <label>{{
                                        "organizationLabel" | t
                                    }}</label>
                                    <input
                                        type="text"
                                        class="form-control form-control-sm"
                                        [(ngModel)]="user.organization"
                                        disabled
                                    />
                                </div>
                                <div class="form-group">
                                    @let languageUpdatedMessage =
                                        "languageUpdatedMessage" | t;
                                    <div class="form-label">
                                        {{ "languageLabel" | t }}
                                    </div>
                                    <cerrix-select
                                        dataUiid="user-profile-language"
                                        [getDataMethod]="languageOptions$"
                                        [value]="languageSelectValue"
                                        (valueChange)="
                                            languageChanged($event, languageUpdatedMessage)
                                        "
                                        [clearable]="false"
                                        bindLabel="Name"
                                        bindValue="ID"
                                    ></cerrix-select>
                                </div>
                            </div>
                        </div>
                    </div>

                    @if (user.passwordChangeAllowed) {
                        @let passwordUpdatedMessage =
                            "passwordUpdatedMessage" | t;
                        @let successTitle = "successTitle" | t;
                        @let updateFailedTitle = "updateFailedTitle" | t;
                        <div class="col-12 col-md-6">
                            <div class="detail-page-card">
                                <div class="detail-page-card-title">
                                    {{ "changePasswordTitle" | t }}
                                </div>
                                <div class="detail-page-card-actions">
                                    <button
                                        class="btn btn-raised"
                                        (click)="
                                            changePassword(
                                                passwordUpdatedMessage,
                                                successTitle,
                                                updateFailedTitle
                                            )
                                        "
                                    >
                                        <i class="fas fa-unlock"></i>
                                        <span class="ms-2">{{
                                            "updatePasswordButton" | t
                                        }}</span>
                                    </button>
                                </div>
                                <div
                                    class="detail-page-card-body padded cerrix-control-sm form-group-styling"
                                >
                                    <div class="form-group">
                                        <label>{{
                                            "usernameLabel" | t
                                        }}</label>
                                        <input
                                            type="text"
                                            class="form-control form-control-sm"
                                            [(ngModel)]="user.username"
                                            disabled
                                        />
                                    </div>
                                    <div class="form-group">
                                        <label>{{
                                            "oldPasswordLabel" | t
                                        }}</label>
                                        <input
                                            type="password"
                                            class="form-control form-control-sm"
                                            [(ngModel)]="passwordChangeModel.oldPassword"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <label>{{
                                            "newPasswordLabel" | t
                                        }}</label>
                                        <input
                                            type="password"
                                            class="form-control form-control-sm"
                                            [(ngModel)]="passwordChangeModel.newPassword"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <label>{{
                                            "confirmNewPasswordLabel" | t
                                        }}</label>
                                        <input
                                            type="password"
                                            class="form-control form-control-sm"
                                            [(ngModel)]="passwordChangeModel.newPasswordConfirm"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>

                <user-audit [audit]="user.audit" [loadOnStartup]="true"></user-audit>
            </div>

            @if (user) {
                <div
                    [attr.name]="'notificationSettingsMenuLabel' | t"
                    menuItemId="notification-settings"
                    menuicon="fas fa-bell"
                    menusystemitem
                >
                    <user-notification-settings
                        [userModel]="user"
                        [parentTab]="tab"
                    ></user-notification-settings>
                </div>
            }

            <div
                [attr.name]="'rolesMenuLabel' | t"
                menuItemId="roles"
                menuicon="fas fa-user-tag"
                menusystemitem
            >
                <div class="detail-page-action-bar">
                    <span
                        class="date-edited"
                        [innerHTML]="'rolesHelpText' | t"
                    ></span>
                </div>

                <role-assign
                    [moduleRoles]="user.moduleRoles"
                    [userModel]="user"
                    [allowChange]="false"
                >
                </role-assign>
            </div>
            <div
                [attr.name]="'apiKeysMenuLabel' | t"
                menuItemId="api-keys"
                menuicon="fas fa-key"
                menusystemitem
            >
                <api-key-overview></api-key-overview>
            </div>
            @if (ipConfigType) {
                <div
                    [attr.name]="'ipWhitelistingMenuLabel' | t"
                    menuItemId="ip-whitelisting"
                    menuicon="fal fa-location"
                    menusystemitem
                >
                    <standingdata-generic
                        [type]="ipConfigType"
                        [name]="'ipConfigLabel' | t"
                    ></standingdata-generic>
                </div>
            }
        </div>
    </div>
}
